import Component from '@glimmer/component';
import { PrismIcon } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import changeColorClass from 'lumen/helpers/change-color-class';
import type { Carecommendation } from 'lumen/models';

interface HotelPricingAssistantRecommendationActionStateSignature {
  Args: {
    hasSmallText?: boolean;
    recommendationObject: Carecommendation;
    showPriceChangeDetails?: boolean;
  };
}

export default class HotelPricingAssistantRecommendationActionState extends Component<HotelPricingAssistantRecommendationActionStateSignature> {
  // Workaround to get bold class to pass to a translation, while taking the hasSmallText argument into account
  get pushedTranslationBoldTextClass(): string {
    if (this.args.hasSmallText) {
      return 'text-200--bold';
    }

    return 'text-300--bold';
  }

  <template>
    {{! Optional hasSmallText arg in case we need the translations to be small-text. Used in case of DayPricingAssistant component }}
    {{#if @recommendationObject.isBeingPushed}}
      <div
        class={{if
          @showPriceChangeDetails
          "recommendation-action-state__price-change flex w-full flex-row items-center justify-between"
        }}
      >
        {{#if @showPriceChangeDetails}}
          <div class="flex items-center gap-100">
            <span
              class={{changeColorClass
                @recommendationObject.formattedDifferenceBetweenRecommendationAndOwnRate.difference
              }}
            >
              <PrismIcon
                @color="inherit"
                @name={{if
                  @recommendationObject.formattedDifferenceBetweenRecommendationAndOwnRate.isPositiveDifference
                  "arrow-up"
                  "arrow-down"
                }}
                @size="small"
              />
            </span>
            <p
              class={{if @hasSmallText "text-200--regular" "text-300--regular"}}
            >
              {{t
                "pricing_assistant.day_tile.pushed"
                class=this.pushedTranslationBoldTextClass
                htmlSafe=true
                priceFrom=@recommendationObject.carate.formattedRate
                priceTo=@recommendationObject.formattedPriceToShow
              }}
            </p>
          </div>
        {{/if}}
      </div>
    {{/if}}
  </template>
}
